var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"64","width":"6"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }